export const TransactionActionTypes = {
  FETCH_PRICES_REQUEST: '@@transaction/FETCH_PRICES_REQUEST',
  FETCH_PRICES_SUCCESS: '@@transaction/FETCH_PRICES_SUCCESS',
  FETCH_PRICES_FAILURE: '@@transaction/FETCH_PRICES_FAILURE',
}

export const transactionInitialState = {
  prices: [],
  isLoading: false
}